import {SURVEY_ANSWER_STATE_TYPE} from "@/common/consts/response.js";
import {ENROLMENT_RESPONSE_NAMESPACE, SURVEY_RESPONSE_NAMESPACE} from "@/common/store";
import {isAllowEdit} from "@/iamteacherpc/utils/survey.js";
import {getNowDate, toResponseViewFormat} from '@common/utils/date';

export default {
    methods: {
        checkResponsePeriod() {
            const startDate = this.$store.state.surveyResponse.survey.startDate;

            if (getNowDate() < new Date(startDate)) {
                this.$showAlert({
                    title: this.$t('SurveyResponseDefault_notResponsePeriod'),
                    desc: this.$t('SurveyResponseDefault_notResponsePeriodDesc', {
                        startDate: toResponseViewFormat(startDate),
                    }),
                    width: 320,
                });

                return false;
            }

            return true;
        },

        checkTryAnswerWhenAnswerStateIsDeny(event, process) {
            const responseNamespace = this.$route.name;

            /**
             * 설문응답
             */
            if (responseNamespace === SURVEY_RESPONSE_NAMESPACE) {
                const allowEditOption = isAllowEdit({surveyOptionList: this.$store.state.surveyResponse.survey.surveyOptions});
                const preQuestionAnswerState = this.$store.state.surveyResponse.survey.preQuestionAnswerState;

                if (!this.checkResponsePeriod()) {
                    event.preventDefault();
                    return true;
                }

                if (!this.checkResponsePeriod(event) || !allowEditOption || preQuestionAnswerState !== SURVEY_ANSWER_STATE_TYPE.DENY) {
                    return false;
                }

                event.preventDefault();

                this.$showConfirm({
                    title: this.$t('checkTryAnswerWhenAnswerStateIsDeny_confirmAnswer'),
                    desc: this.$t('checkTryAnswerWhenAnswerStateIsDeny_confirmAnswerDesc'),
                    okText: this.$t('checkTryAnswerWhenAnswerStateIsDeny_doAnswer'),
                    cancelText: this.$t('common_no'),
                    ok: () => {
                        this.$store.commit(`${SURVEY_RESPONSE_NAMESPACE}/setPreQuestionAnswerState`, {answerState: SURVEY_ANSWER_STATE_TYPE.ANSWER});
                        process && process();
                    }
                });

                return true;
            }

            /**
             * 수강신청 응답
             */
            if (responseNamespace === ENROLMENT_RESPONSE_NAMESPACE) {
                const answerStateType = this.$store.state.enrolmentResponse.survey.answerStateType;
                if (answerStateType !== SURVEY_ANSWER_STATE_TYPE.DENY) {
                    return false;
                }

                event.preventDefault();

                this.$showConfirm({
                    title: this.$t('checkTryAnswerWhenAnswerStateIsDeny_confirmApply'),
                    desc: this.$t('checkTryAnswerWhenAnswerStateIsDeny_confirmApplyDesc'),
                    okText: this.$t('checkTryAnswerWhenAnswerStateIsDeny_doApply'),
                    cancelText: this.$t('common_no'),
                    ok: () => {
                        this.$store.commit(`${ENROLMENT_RESPONSE_NAMESPACE}/changeAnswerState`, {answerStateType: SURVEY_ANSWER_STATE_TYPE.ANSWER});
                        process && process();
                    }
                });

                return true;
            }
        },
    }
}
